var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBranch48Filled = function SvgIconBranch48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.328 27.16a5.29 5.29 0 0 0-5.236-4.66h-3.7v-2.28a5.296 5.296 0 0 0 4-5.12v-.8a5.306 5.306 0 0 0-5.3-5.3h-.8a5.306 5.306 0 0 0-5.3 5.3v.8a5.298 5.298 0 0 0 4 5.12v2.28h-3.7a5.292 5.292 0 0 0-5.236 4.66 5.3 5.3 0 0 0-4.064 5.14v.8a5.306 5.306 0 0 0 5.3 5.3h.8a5.306 5.306 0 0 0 5.3-5.3v-.8a5.295 5.295 0 0 0-3.896-5.088 1.895 1.895 0 0 1 1.8-1.312h10.8a1.897 1.897 0 0 1 1.8 1.312 5.292 5.292 0 0 0-3.898 5.088v.8a5.306 5.306 0 0 0 5.3 5.3h.8a5.306 5.306 0 0 0 5.3-5.3v-.8a5.298 5.298 0 0 0-4.07-5.14Z",
    fill: "current"
  })));
};
export default SvgIconBranch48Filled;